import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class CommercialService {

  constructor(private http: HttpClient) { }

  saveCommercial(data) {
    return this.http.put(
      `${environment.apiHost}/v1/commercial-tracing`,
      data
    );
  }

  updateCommercial(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/commercial-tracing`,
      data
    );
  }

  get(data) {
    return this.http.post(
      `${environment.apiHost}/v1/commercial-tracing`,
      data
    );
  }

  getEnterprises(data) {
    return this.http.post(
      `${environment.apiHost}/v1/vendor`,
      data
    );
  }

  closeCommercial(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/commercial-tracing/close`,
      data
    );
  }
}
